/**
 * Logger features
 */

/**
 * A logger singleton that implements the console api
 */
let _logger

/**
 * Set the logger singleton
 * @param {Object} logger A logger which implements the console api
 */
export function setLogger (logger) {
  _logger = logger
}

/**
 * Get the logger singleton
 * @returns {Object|undefined} The logger singleton which implements the console api if
 * it was set
 */
export function getLogger () {
  return _logger
}

/**
 * Set and then get the logger singleton
 * @param {Object} logger A logger which implements the console api
 */
export function getSetLogger (logger) {
  setLogger(logger)
  return getLogger()
}

/**
 * Format an error object for logging
 * @param {Error} error The error object
 * @param {String} customMessage Optional custom message to override error.message
 * @returns {Object} Formatted error object for logging
 */
export function formatErrorForLogging (error, customMessage) {
  if (error instanceof Error) {
    return {
      message: customMessage || error.message || 'Unknown error',
      error: error.message,
      stack: error.stack,
      name: error.name,
      code: error.code,
    }
  }

  // Fallback for non-Error objects
  const errorString = error ? String(error) : 'Unknown error'
  return {
    message: customMessage || errorString,
    error: errorString,
  }
}

/**
 * Log an error
 * @param {Error} error An error
 */
export function log (error) {
  if (!_logger || !_logger.error) {
    // eslint-disable-next-line no-console
    if (!console.error) {
      return null
    }
    // eslint-disable-next-line no-console
    console.error(error || 'Unknown error')
  }

  // Format the error properly for Winston
  if (error instanceof Error) {
    return _logger.error({
      message: error.message || 'Unknown error',
      error: error.message,
      stack: error.stack,
      name: error.name,
      code: error.code,
    })
  }

  // Fallback for non-Error objects
  return _logger.error(error || 'Unknown error')
}

export default {
  setLogger,
  getLogger,
  getSetLogger,
  log,
  formatErrorForLogging,
}
